import React, { useState, useEffect } from 'react';

interface WelcomeMessageProps {
  userName: string;
  message: string;
  timestamp: Date;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ userName, message, timestamp }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    if (currentIndex < message.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + message[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 30); // Typing speed: 30ms per character

      return () => clearTimeout(timeout);
    } else if (!isTypingComplete) {
      setIsTypingComplete(true);
    }
  }, [currentIndex, message, isTypingComplete]);

  return (
    <div className="flex justify-start">
      <div className="max-w-3xl px-4 py-2 rounded-jobesta bg-white border border-jobesta-gray-40 text-jobesta-gray-90">
        <p className="whitespace-pre-wrap break-words text-jobesta-gray-90">
          {displayedText}
          {!isTypingComplete && <span className="animate-pulse">|</span>}
        </p>
        <p className="text-xs mt-1 text-jobesta-gray-60">
          {timestamp.toLocaleTimeString()}
        </p>
      </div>
    </div>
  );
};

export default WelcomeMessage;

export const WELCOME_MESSAGES = [
  "Hello {name}! How can I help you today?",
  "What's on your mind today?",
  "Hi {name}! What can I assist you with?",
  "Ready to take your career to the next level, {name}?",
  "Good to see you, {name}! Let's work on your career goals.",
  "What career challenge can I help you tackle today?",
  "Hey {name}! What brings you here today?",
  "Looking forward to helping you today! What's your focus?",
  "Welcome back, {name}! What would you like to achieve today?",
  "Let's make your career goals happen! How can I help?"
];

export const getRandomWelcomeMessage = (userName: string): string => {
  const randomIndex = Math.floor(Math.random() * WELCOME_MESSAGES.length);
  const message = WELCOME_MESSAGES[randomIndex];
  return message.replace(/{name}/g, userName || 'there');
};
